import LoansModel from '../Apis/Loans'
import Controller from './Controller'

export default class LoansController extends Controller {
  constructor() {
    super(new LoansModel())
  }
}
